import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { createLoadingSelector } from '@hobs/utils/loading';
import WithEscNavigation from '@hobs/hocs/WithEscNavigation';
import PageHeader from '@hobs/components/PageHeader';
import { queryOData, resetOData } from '@hobs/actions/odata';
import { getServiceRequest } from '@hobs/actions/serviceRequests';
import ShortId from 'shortid';
import { SERVICE_REQUEST_NAVIGATION_ORIGIN } from '@hobs/utils/constants';
import { ServiceRequestNavContext } from '@hobs/components/ServiceRequestNavContext';
import { PageLinks } from '../RequestInformation/PageLinks';

import AuditLogGrid from './AuditLogGrid';

import './AuditLog.scss';

class AuditLog extends React.PureComponent {
  componentDidMount() {
    const { match, getServiceRequest } = this.props;
    getServiceRequest(match.params.serviceRequestId);
  }

  getBackNavigationUrl = (navContext, history) => {
    if (navContext === SERVICE_REQUEST_NAVIGATION_ORIGIN.AnnexOverview) {
      const withSearch =
        history && history.location && history.location.search
          ? history.location.search
          : '';
      return `/annex-overview${withSearch}`;
    } else if (navContext === SERVICE_REQUEST_NAVIGATION_ORIGIN.Orders) {
      return '/orders';
    } else if (navContext === SERVICE_REQUEST_NAVIGATION_ORIGIN.Tickets) {
      return '/tickets';
    }
    return '/annex-overview';
  };

  navigateBack = (navContext, previousPageHistory) => () => {
    const { history } = this.props;
    history.push(this.getBackNavigationUrl(navContext, previousPageHistory));
  };

  getDiscussionPath() {
    const { match } = this.props;
    return `${match.url}/discussion`;
  }

  render() {
    const { t, match, serviceRequest, getServiceRequest } = this.props;
    return (
      <>
        <div className="service-request-annex-auditlog--heading">
          <ServiceRequestNavContext.Consumer>
            {nav => (
              <>
                {this.props.withEscNavigationCallback(
                  this.navigateBack(
                    nav.serviceRequestNavigation,
                    nav.previousPageHistory
                  )
                )}
                <PageHeader
                  to={this.getBackNavigationUrl(
                    nav.serviceRequestNavigation,
                    nav.previousPageHistory
                  )}
                  title={t('Request history') + ' - '}
                  unit={{
                    code: serviceRequest.partyCode,
                    name: serviceRequest.unitName,
                    number: serviceRequest.requestNumber
                  }}
                  status={{
                    name: serviceRequest.statusGridName,
                    id: serviceRequest.statusId
                  }}
                />
              </>
            )}
          </ServiceRequestNavContext.Consumer>
          <PageLinks
            key={ShortId.generate()}
            serviceRequestId={match.params.serviceRequestId}
            discussion={{
              status: serviceRequest.discussionStatus,
              initials: t('HN'),
              onDiscussionClose: () =>
                getServiceRequest(match.params.serviceRequestId),
              isSeen: serviceRequest.isLastDiscussionSeen
            }}
            discussionPath={this.getDiscussionPath()}
          />
        </div>
        <AuditLogGrid />
      </>
    );
  }
}

AuditLog.propTypes = {
  match: PropTypes.object,
  t: PropTypes.func,
  getServiceRequest: PropTypes.func,
  serviceRequest: PropTypes.object,
  getAssignmentServiceRequest: PropTypes.func,
  history: PropTypes.object,
  withEscNavigationCallback: PropTypes.func
};

const oDataLoading = createLoadingSelector(['OData']);
const mapStateToProps = state => ({
  isLoading: oDataLoading(state),
  oData: state.odata,
  serviceRequest: state.serviceRequests.item
});

const mapDispatchToProps = {
  queryOData,
  resetOData,
  getServiceRequest
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(WithEscNavigation(AuditLog)))
);
